// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer-snippet{border:1px solid #c6ced5;background-color:#fff;border-radius:4px;box-shadow:0 2px 4px #c6ced5;margin-bottom:40px}@media screen and (max-width: 62.5625em){.lawyer-snippet{margin-bottom:16px}}.lawyer-snippet__panel{margin-top:16px}.lawyer-snippet__follow{padding-top:16px;padding-left:60px}.lawyer-snippet__top{padding:16px}.lawyer-snippet__bottom{padding-bottom:16px}\n", ""]);
// Exports
module.exports = exports;
